/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsProfilePicturesBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, title: string, isCraftsmanOrganisation: boolean, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, bannerImage?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, profile?: { __typename: 'OrganisationProfile', id: string, slug: string } | null };

export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, bannerImage?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } };

export const OrganisationDetailsProfilePicturesBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsProfilePicturesBox_ViewerOrganisation on ViewerOrganisation {
  id
  title
  isCraftsmanOrganisation
  logo {
    ...AttachmentSnapshot
  }
  bannerImage {
    ...AttachmentSnapshot
  }
  profile {
    id
    slug
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesDocument = gql`
    mutation OrganisationDetailsProfilePicturesBox_ModifyOrganisationPictures($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      title
      logo {
        ...AttachmentSnapshot
      }
      bannerImage {
        ...AttachmentSnapshot
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationFn = Apollo.MutationFunction<OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation, OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationVariables>;

/**
 * __useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsProfilePicturesBoxModifyOrganisationPicturesMutation, { data, loading, error }] = useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation, OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation, OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationVariables>(OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesDocument, options);
      }
export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationHookResult = ReturnType<typeof useOrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation>;
export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationResult = Apollo.MutationResult<OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation>;
export type OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutation, OrganisationDetailsProfilePicturesBox_ModifyOrganisationPicturesMutationVariables>;